/* eslint-disable */
import { HttpClient, HttpEvent, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { toQueryString } from '../../api-helpers';
import { MailAccountGetMessageListResponseDto, fixMailAccountGetMessageListResponseDtoFromJson } from '../dto/mail-account-get-message-list-response-dto';

export interface GetCustomerMailAccountGetMessageListQueryParams {
  accountId: number;
  folderPath: string;
}

export interface GetCustomerMailAccountGetMessageListParams {
  query: GetCustomerMailAccountGetMessageListQueryParams;
}

export function httpGetCustomerMailAccountGetMessageList(http: HttpClient, data: GetCustomerMailAccountGetMessageListParams, options?: { reportProgress?: boolean; observe?: 'body' }): Observable<MailAccountGetMessageListResponseDto>;
export function httpGetCustomerMailAccountGetMessageList(http: HttpClient, data: GetCustomerMailAccountGetMessageListParams, options?: { reportProgress?: boolean; observe?: 'events' }): Observable<HttpEvent<MailAccountGetMessageListResponseDto>>;
export function httpGetCustomerMailAccountGetMessageList(http: HttpClient, data: GetCustomerMailAccountGetMessageListParams, options: { reportProgress?: boolean; observe?: 'body' | 'events' } = {}): Observable<any> {
  return http.get<MailAccountGetMessageListResponseDto>(`{placeholder}/customer/mail-account/get-message-list?${toQueryString(data.query)}`, options as any).pipe(
    tap((eventOrDto) => {
      const dto = eventOrDto instanceof HttpResponse ? eventOrDto.body : options.observe === 'events' ? null : eventOrDto as unknown as MailAccountGetMessageListResponseDto;
      fixMailAccountGetMessageListResponseDtoFromJson(dto);
    })
  );
};

export const urlGetCustomerMailAccountGetMessageList = (baseUrl: string, data: GetCustomerMailAccountGetMessageListParams) => {
  return `${baseUrl}/customer/mail-account/get-message-list?${toQueryString(data.query)}`;
};
